export default __webpack_public_path__ + "static/why-1-50bbf27afbac98fb75769b7af8c844c9.png";